import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch, Redirect} from 'react-router-dom';
import {Tabs, Tab} from 'react-bootstrap';
import { not } from 'ramda';
import Spinner from 'spinner';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import {DocumentList} from 'components/documents';
import {LinkInfo, ButtonDangerDelete} from 'components/buttons';
import Box from 'components/box';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';

import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';

import {loadInstitutionDetail, onLoadParentByParentProperty, loadStaffByUser} from 'redux/actions/portal/institutions';
import {deleteInstitution} from '../../redux/actions/admin/institution';
import {TabsWrapper, InstImage, InstWrapper} from 'components/common';
import Subordinate from './subordinate';
import SubordinatePersonal from './subordinate-personal';
import SubordinateServices from './subordinate-services';

import hospital from 'images/general/hospital.svg';
import close from 'images/general/close.svg';


const mapStateToProps = (state) => ({
  institutionDetail: state.institutions.get('institutionDetail'),
  institutionParent: state.institutions.get('parentInst'),
  user: state.auth.get('user'),
  staff: state.institutions.get('currentUserInstitutions')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: id => dispatch(loadInstitutionDetail(id)),
  onLoadParentByParentProperty: parent => dispatch(onLoadParentByParentProperty(parent)),
  deleteInstitution: (id, parent) => dispatch(deleteInstitution(id, parent)),
  loadStaff: (id, role) => dispatch(loadStaffByUser(id, role))
});

class InsitutionDetail extends Component {

  state = {
    deleteModalOpen: false,
    activeKey: 1
  }

  toggleDeleteModal = () => {
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen
    });
  }

  toggleDeleteModalDeleteInstitution = () => {
    this.props.deleteInstitution(this.props.match.params.id, this.props.institutionParent.get('id'));
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen
    });
  }

  selectTab = key => {
    switch (key) {
      case 1:
        this.props.history.push(`${this.props.match.url}/subordinate-institutions`)
        break
      case 2:
        this.props.history.push(`${this.props.match.url}/subordinate-personal`)
        break
      case 3:
        this.props.history.push(`${this.props.match.url}/subordinate-services`)
        break
    }
    this.setState(() => ({activeKey: key}))
  }

  checkActiveKey = pathname => {
    let activeKey
    if(pathname.indexOf('subordinate-institutions') > (-1)) {
      activeKey = 1
    } else if (pathname.indexOf('subordinate-personal') > (-1)) {
      activeKey = 2
    } else if (pathname.indexOf('subordinate-services') > (-1)) {
      activeKey = 3
    } else {
      activeKey = 1
    }
    this.setState(()=>({ activeKey }))
  }

  renderBreadcrumbs = item => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution) return null
    return (
      <Breadcrumbs>
        <li><Link to="/admin/">Головна</Link></li>
        <li><Link to="/admin/institutions">Установи</Link></li>
        <li><Link to={`/admin/institutions/detail/${item.get('id')}`}>{item.get('short_title')}</Link></li>
      </Breadcrumbs>
    )
  }

  renderDeleteButton = item => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    const deleteButton = item.get('subordinate_institutions') === true ||
      (isAdminInstitution && this.props.staff.getIn(['results', 0, 'institution']) === item.get('id'))
    return deleteButton
      ? null
      : <ButtonDangerDelete value="Видалити" onClick={this.toggleDeleteModal}>Видалити</ButtonDangerDelete>
  }

  componentDidMount() {
    this.checkActiveKey(this.props.location.pathname)

    this.props.onLoad(this.props.match.params.id)
    .then(() => {
      return this.props.onLoadParentByParentProperty(this.props.institutionDetail.get('parent'))
    })

    if(!this.props.staff){
      const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
      if(isAdminInstitution) {
        this.props.loadStaff(this.props.user.get('id'), 'is_admin')
      } else {
        this.props.loadStaff(this.props.user.get('id'));
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.location.pathname !== nextProps.location.pathname) {
      this.checkActiveKey(nextProps.location.pathname)
    }
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.onLoad(nextProps.match.params.id)
      .then(() => {
        return this.props.onLoadParentByParentProperty(this.props.institutionDetail.get('parent'))
      })
    }

    if(not(this.props.staff.getIn(['results', 0, 'institution']) === nextProps.staff.getIn(['results', 0, 'institution']))){
      this.props.history.push(`/admin/institutions/detail/${nextProps.staff.getIn(['results', 0, 'institution'])}`)
    }
  }


  render() {
    const item = this.props.institutionDetail;

    if (this.props.isFetching) return <Spinner/>

    if (this.props.institutionDetail === undefined) return <Spinner/>

    const id = this.props.institutionDetail.get('id');

    return (
      <div>
        {this.renderBreadcrumbs(item)}
        <h2>
          {item.get('full_title')}

        </h2>
        {this.props.isFetching ? (
          <Spinner />
        ):(
          <div>

        <Box title4="Детальна інформація">
          <InstWrapper>
            <InstImage>
        {item.get('photo') ? (
          <img src={item.get('photo')} alt="hospital" style={{maxWidth: "300px"}}/>
        ) : (
          <img src={hospital} alt="hospital" style={{width: "250px"}}/>
        )
        }
          </InstImage>
            <DocumentList>
              {item.get('hierarchy_level') > 1 ? (
                 <li><span>Установа верхнього рівня: </span>
                 {(this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser'))
                   ? <strong>{this.props.institutionParent.get('full_title')}</strong>
                   : <Link to={{pathname: `/admin/institutions/detail/${this.props.institutionDetail.get('parent')}`}}>
                     <strong style={{color: "#edbd2f"}}>{this.props.institutionParent.get('full_title')}</strong></Link>
                 }
               </li>
              ): (
                null
              )}
           
            <li><span>Адреса: </span><strong>{item.get('address')}</strong></li>
            <li><span>ЄДРПОУ код: </span><strong>{item.get('edrpou_code')}</strong></li>
            <li><span>КОАТУУ код: </span><strong>{item.get('koatuu_code')}</strong></li>
            <li><span>Опис діяльності: </span>{item.get('description') ? <strong style={{whiteSpace: "pre-wrap"}}>{item.get('description')}</strong> : <strong>Опис відсутній</strong>}</li>
            </DocumentList>
          </InstWrapper>

              <LinkInfo to={`/admin/institutions/detail/${id}/edit`}>Редагувати</LinkInfo>


            {this.renderDeleteButton(item)}

            <TabsWrapper>
              <Tabs activeKey={this.state.activeKey} onSelect={this.selectTab}>
                <Tab eventKey={1} title="Підпорядковані установи">
                 <Switch>
                    <Route exact path={`${this.props.match.path}/subordinate-institutions`} render={
                      (props) => (<Subordinate {...props} detail = {this.props.institutionDetail}/>)
                    }/>
                    <Route exact path={`${this.props.match.path}/subordinate-institutions/:page`} render={
                      (props) => (<Subordinate {...props} detail = {this.props.institutionDetail}/>)
                    }/>
                </Switch>

                </Tab>
                <Tab eventKey={2} title="Персонал">
                  <Switch>
                    <Route exact path={`${this.props.match.path}/subordinate-personal`} render={
                      (props) => (<SubordinatePersonal {...props} institutionTitle = {this.props.institutionDetail.get('short_title')} />)
                    }/>
                    <Route exact path={`${this.props.match.path}/subordinate-personal/:page`} render={
                      (props) => (<SubordinatePersonal {...props} institutionTitle = {this.props.institutionDetail.get('short_title')} />)
                    }/>
                  </Switch>
                </Tab>
                <Tab eventKey={3} title="Медичні послуги">
                  <Switch>
                    <Route exact path={`${this.props.match.path}/subordinate-services`} render={
                      (props) => (<SubordinateServices {...props} institutionTitle = {this.props.institutionDetail.get('short_title')} />)
                    }/>
                    <Route exact path={`${this.props.match.path}/subordinate-services/:page`} render={
                      (props) => (<SubordinateServices {...props} institutionTitle = {this.props.institutionDetail.get('short_title')} />)
                    }/>
                  </Switch>
                </Tab>
              </Tabs>
            </TabsWrapper>
            </Box>

        <ReactModal isOpen={this.state.deleteModalOpen} onRequestClose={this.toggleDeleteModal}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження видалення"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <div>
          <Modal>
            <CloseModal>
              <div>
				         <img src={close} alt="закрити" onClick={this.toggleDeleteModal} />
              </div>
						</CloseModal>
            <ModalContent>
              <h3>Ви впевнені, що хочете видалити установу?</h3>

              <ButtonWrap>
                <ButtonSuccessModal onClick={this.toggleDeleteModalDeleteInstitution} value="Так"/>
                <ButtonDangerModal value="Ні" onClick={this.toggleDeleteModal}/>
              </ButtonWrap>
            </ModalContent>
          </Modal>
          </div>

        </ReactModal>
          </div>
        )}

        <Switch>
          <Redirect exact from="/admin/institutions/detail/:id" to={`/admin/institutions/detail/${this.props.match.params.id}/subordinate-institutions`}/>
        </Switch>
      </div>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(InsitutionDetail);



// WEBPACK FOOTER //
// ./src/admin/institutions/detail.js